<template>
	<label :for="value.id">
		<input type="checkbox" :id="value.id" :checked="checked" @change="checkStatusChange"  />
		<span class="box">
			<i class="fas fa-check"></i>
		</span>
		<span class="text">{{ value.nome }}</span>
	</label>
</template>

<script>
export default {
	name: 'Checkbox',
	props: {
		checked: {
			default: false
		},
		value: {
			type: Object
		}
	},
	model: {
		prop: 'checked',
		event: 'change'
	},
	methods: {
		checkStatusChange (value) {
			this.$emit('change', value)
		}
	}
}
</script>

<style lang="scss" scoped>
label {
	display: flex;
	align-items: center;
	border-radius: 3px;
	cursor: pointer;
	font-weight: 400;
	font-size: 1em;

	&:not(:last-of-type) {
		margin-bottom: 14px;
	}

	input[type=checkbox] {
		display: none;

		&:checked + span.box {
			background-color: $success-color;
		}

		&:checked + span.box i {
			opacity: 1;
		}
	}

	.box {
		width: 26px;
		height: 26px;
		border-radius: 2px;
		background-color: #fff;
		transition: background 300ms ease;
		border: 1px solid $main-color;
		border-radius: 3px;
		display: flex;
		align-items: center;
		justify-content: center;

		i {
			opacity: 0;
			color: #fff;
			transition: opacity 300ms ease-in;
		}

		&:hover {
			background-color: $success-color;
		}
	}

	.text {
		margin-left: 14px;
	}
}
</style>
